'use strict';

import { graphql } from 'react-relay';

export const sbRespCollectionsRoot = graphql`
    query sbRespCollectionsRootQuery(
        $userId: String = ""
        $fetchUser: Boolean!
        $uriRef: String = ""
        $first: Int!
        $page: Int!
        $localeOrigin: String = ""
        $isTrade: Boolean!
        $showSeller: Boolean!
        $followSearchPages: [String]
        $followSearchTypes: [types] = [SEARCH]
        $contentModuleId: String = ""
        $eligibleAbTest: String = ""
        $userZipCode: String = "0"
        $fetchSb: Boolean!
        $disableForceFacet: Boolean = false
    ) {
        viewer {
            ...getDomainLinksSb_viewer
            ...SbRespCollectionsLayout_viewer
            ...detectPageExistsAndRedirect_viewer
        }
    }
`;
